import React from 'react';
import Disclaimer from '../components/Disclaimer';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-black">
      <Disclaimer />
      <Header />
      <div className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white">
            Politique de confidentialité
          </h1>

          <article className="glass-strong rounded-2xl p-8 md:p-12 border border-white/10 space-y-8 text-white/80 leading-relaxed">
            <section>
              <p className="mb-4">
                <strong className="text-white">Dernière mise à jour : 08 décembre 2025</strong>
              </p>
              <p className="mb-4">
                Rouge Bets s'engage à protéger votre vie privée et vos données personnelles. Cette politique de confidentialité explique comment nous collectons, 
                utilisons, stockons et protégeons vos informations lorsque vous utilisez notre site web rougebets.com.
              </p>
              <p>
                En utilisant notre site, vous acceptez les pratiques décrites dans cette politique. Si vous n'acceptez pas cette politique, veuillez ne pas utiliser 
                notre site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">1. Informations que nous collectons</h2>
              <p className="mb-4">
                Nous collectons plusieurs types d'informations lorsque vous utilisez notre site :
              </p>
              <h3 className="text-xl font-semibold text-white mb-3">Informations que vous nous fournissez directement</h3>
              <ul className="list-disc list-inside mb-4 space-y-2">
                <li>Nom et adresse email lorsque vous utilisez notre formulaire de contact</li>
                <li>Messages et communications que vous nous envoyez</li>
                <li>Informations que vous choisissez de partager via nos formulaires</li>
              </ul>
              <h3 className="text-xl font-semibold text-white mb-3">Informations collectées automatiquement</h3>
              <ul className="list-disc list-inside mb-4 space-y-2">
                <li>Adresse IP et informations sur votre appareil</li>
                <li>Type de navigateur et système d'exploitation</li>
                <li>Pages visitées et temps passé sur le site</li>
                <li>Référents et sources de trafic</li>
                <li>Cookies et technologies similaires (voir notre politique des cookies)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">2. Comment nous utilisons vos informations</h2>
              <p className="mb-4">Nous utilisons les informations collectées pour :</p>
              <ul className="list-disc list-inside mb-4 space-y-2">
                <li>Répondre à vos demandes et communications</li>
                <li>Améliorer notre site web et nos services</li>
                <li>Analyser l'utilisation du site et les tendances</li>
                <li>Personnaliser votre expérience sur le site</li>
                <li>Envoyer des communications importantes concernant nos services</li>
                <li>Respecter nos obligations légales et réglementaires</li>
                <li>Protéger nos droits et prévenir la fraude</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">3. Partage de vos informations</h2>
              <p className="mb-4">
                Nous ne vendons pas vos données personnelles. Nous pouvons partager vos informations uniquement dans les cas suivants :
              </p>
              <ul className="list-disc list-inside mb-4 space-y-2">
                <li><strong className="text-white">Prestataires de services :</strong> Nous pouvons partager des informations avec des prestataires tiers qui nous aident à exploiter notre site (hébergement, analyse, etc.), sous réserve d'accords de confidentialité stricts.</li>
                <li><strong className="text-white">Obligations légales :</strong> Nous pouvons divulguer des informations si la loi l'exige ou pour répondre à des procédures légales.</li>
                <li><strong className="text-white">Protection des droits :</strong> Nous pouvons partager des informations pour protéger nos droits, votre sécurité, ou celle d'autrui.</li>
                <li><strong className="text-white">Liens d'affiliation :</strong> Lorsque vous cliquez sur des liens vers des opérateurs de paris, ces sites peuvent collecter leurs propres informations selon leurs propres politiques de confidentialité.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">4. Cookies et technologies similaires</h2>
              <p className="mb-4">
                Nous utilisons des cookies et technologies similaires pour améliorer votre expérience, analyser l'utilisation du site, et personnaliser le contenu. 
                Pour plus d'informations, consultez notre <a href="/cookies" data-discover="true" className="text-toxic-green hover:text-toxic-cyan underline">Politique des cookies</a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">5. Sécurité de vos données</h2>
              <p className="mb-4">
                Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données personnelles contre l'accès 
                non autorisé, la perte, la destruction ou l'altération. Cependant, aucune méthode de transmission sur Internet n'est totalement sécurisée, et nous 
                ne pouvons garantir une sécurité absolue.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">6. Vos droits</h2>
              <p className="mb-4">Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul className="list-disc list-inside mb-4 space-y-2">
                <li><strong className="text-white">Droit d'accès :</strong> Vous pouvez demander une copie de vos données personnelles que nous détenons</li>
                <li><strong className="text-white">Droit de rectification :</strong> Vous pouvez demander la correction de données inexactes</li>
                <li><strong className="text-white">Droit à l'effacement :</strong> Vous pouvez demander la suppression de vos données dans certaines circonstances</li>
                <li><strong className="text-white">Droit à la limitation :</strong> Vous pouvez demander la limitation du traitement de vos données</li>
                <li><strong className="text-white">Droit à la portabilité :</strong> Vous pouvez demander le transfert de vos données</li>
                <li><strong className="text-white">Droit d'opposition :</strong> Vous pouvez vous opposer au traitement de vos données dans certaines circonstances</li>
                <li><strong className="text-white">Droit de retirer votre consentement :</strong> Vous pouvez retirer votre consentement à tout moment</li>
              </ul>
              <p>
                Pour exercer ces droits, contactez-nous à <a href="mailto:info@rougebets.com" className="text-toxic-green hover:text-toxic-cyan underline">info@rougebets.com</a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">7. Conservation des données</h2>
              <p className="mb-4">
                Nous conservons vos données personnelles uniquement aussi longtemps que nécessaire pour les finalités décrites dans cette politique, sauf si une 
                période de conservation plus longue est requise ou autorisée par la loi. Lorsque nous n'avons plus besoin de vos données, nous les supprimons de 
                manière sécurisée.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">8. Transferts internationaux</h2>
              <p className="mb-4">
                Vos données peuvent être transférées et traitées dans des pays en dehors de l'Union Européenne. Dans ce cas, nous nous assurons que des garanties 
                appropriées sont en place pour protéger vos données conformément au RGPD.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">9. Modifications de cette politique</h2>
              <p className="mb-4">
                Nous pouvons modifier cette politique de confidentialité occasionnellement. Toute modification sera publiée sur cette page avec une date de mise à 
                jour révisée. Nous vous encourageons à consulter régulièrement cette page pour rester informé de nos pratiques.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">10. Contact</h2>
              <p className="mb-4">
                Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, contactez-nous :
              </p>
              <ul className="list-none space-y-2">
                <li><strong className="text-white">Email :</strong> <a href="mailto:info@rougebets.com" className="text-toxic-green hover:text-toxic-cyan underline">info@rougebets.com</a></li>
                <li><strong className="text-white">Téléphone :</strong> <a href="tel:+33742963066" className="text-toxic-green hover:text-toxic-cyan underline">+33 7 42 96 30 66</a></li>
                <li><strong className="text-white">Adresse :</strong> Paris, France</li>
              </ul>
            </section>
          </article>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;

